import { render, staticRenderFns } from "./AssignmentsWidget.vue?vue&type=template&id=665d4a6e&"
import script from "./AssignmentsWidget.vue?vue&type=script&lang=js&"
export * from "./AssignmentsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports